import {
    TCITenantAppType,
    TCITenantAppCategory
} from "./tci-application";
import { ITCIFile } from "./tci-util";
import { ITCISupplementConnector } from "./tci-tenant-svcs";
import { strEnum } from "../../types";


export interface ITCISupplement {

    /**
     * Supplement Id
     */
    supplementId: string;
    /**
     * Tenant Type
     */
    tenantType: TCITenantAppType;
    /**
     * Supplement Upload timestamp
     */
    uploadTime: number;
    /**
     * Supplement FileName
     */
    fileName?: string;
    /**
     * Supplement Description
     */
    description?: string;
    /**
     * supplement connector
     */
    connector: ITCISupplementConnector;
    /**
     * supplement file names
     */
    files: string[];
}

export class SupplementColResMap {
    public static CATEGORY = new SupplementColResMap("Category", "category");
    public static SUPPLEMENTED_FOR = new SupplementColResMap("Supplemented for", "connector.name");
    public static USAGE = new SupplementColResMap("Usage", "appCount");
    public static DATE = new SupplementColResMap("Date", "uploadTime");
    public static SUPPLEMENT_FILE = new SupplementColResMap("Supplement File", "files");
    public static DESCRIPTION = new SupplementColResMap("Description", "description");

    private constructor(private _colKey: string, private _resKey: string) {}

    private static allItems = [
        SupplementColResMap.CATEGORY,
        SupplementColResMap.SUPPLEMENTED_FOR,
        SupplementColResMap.USAGE,
        SupplementColResMap.DATE,
        SupplementColResMap.SUPPLEMENT_FILE,
        SupplementColResMap.DESCRIPTION,
    ];
    public static getKey(key: string): string {
        const POS =  SupplementColResMap.allItems.findIndex(v => v.getColKey() === key);
        return POS > -1 ? SupplementColResMap.allItems[POS].getResKey() : "";
    }

    public static getSortableRows() {
        return {
            CATEGORY: SupplementColResMap.CATEGORY.getColKey(),
            SUPPLEMENTED_FOR: SupplementColResMap.SUPPLEMENTED_FOR.getColKey(),
            USAGE: SupplementColResMap.USAGE.getColKey(),
            DATE: SupplementColResMap.DATE.getColKey(),
            SUPPLEMENT_FILE: SupplementColResMap.SUPPLEMENT_FILE.getColKey(),
            DESCRIPTION: SupplementColResMap.DESCRIPTION.getColKey()
        };
    }

    getColKey(): string {
        return this._colKey;
    }

    getResKey(): string {
        return this._resKey;
    }
}

export enum TCI_CREATE_SUPPLEMENT_UI_TYPE {
    FILE_UPLOAD
}
export interface ITCISupplementTypeMetaDataOption {
    label: string;
    dropDownLabel: string;
    buttons: ITCITenantSupplementCreateUIBindingButton[];
}
export interface ITCITenantSupplementCreateUIBindingButton {
    label: string;
    createOption: TCISupplementCreateOption;
    uiType: TCI_CREATE_SUPPLEMENT_UI_TYPE;
}

export class TCISupplementCreateOption {

    public static BW_SUPP_IMPORT = new TCISupplementCreateOption(1, true, TCITenantAppType.bw);
    public static FLOGO_SUPP_IMPORT = new TCISupplementCreateOption(2, true, TCITenantAppType.flogo);

    public static allItems = [
        TCISupplementCreateOption.BW_SUPP_IMPORT,
        TCISupplementCreateOption.FLOGO_SUPP_IMPORT
    ];

    public static getDefaultOption(tenantType: TCITenantAppType): TCISupplementCreateOption {
        const items = TCISupplementCreateOption.allItems
            .filter(item => item.tenantType.equals(tenantType) && item.isDefault);
        if (items && items.length > 0) {
            return items[0];
        }
        return null;
    }

    public valueOf(): number {
        return this.option;
    }

    public toString(): string {
        return this.option.toString();
    }

    constructor(private option: number, public isDefault: boolean, public tenantType: TCITenantAppType) {
    }
}

export interface ITCISupplementUploadFileCheckResult {
    type: string;
    fileContent: ITCIFile;
    name: string;
    error: boolean;
    errorMsg: string;
}

export interface ITCISupplementUploadSupportedFile {
    extension: string;
    finalFileName?: string;
    optional?: boolean;
}
export class SupplementTypeMetaData {

    public static bw = new SupplementTypeMetaData(
        TCITenantAppType.bw,
        TCITenantAppCategory.INTEGRATE,
        [{
            label: "BusinessWorks",
            dropDownLabel: "Plugin/Driver",
            buttons: [{
                label: "Upload",
                createOption: TCISupplementCreateOption.BW_SUPP_IMPORT,
                uiType: TCI_CREATE_SUPPLEMENT_UI_TYPE.FILE_UPLOAD
            }],
        }],
        true,
        "BusinessWorks");

    public static flogo = new SupplementTypeMetaData(
        TCITenantAppType.flogo,
        TCITenantAppCategory.DEVELOP,
        [{
            label: "Flogo",
            dropDownLabel: "Connector",
            buttons: [{
                label: "Upload",
                createOption: TCISupplementCreateOption.FLOGO_SUPP_IMPORT,
                uiType: TCI_CREATE_SUPPLEMENT_UI_TYPE.FILE_UPLOAD
            }],
        }],
        true,
        "Flogo");

    public static allItems = [
        SupplementTypeMetaData.flogo,
        SupplementTypeMetaData.bw
    ];

    public static getAllItems(): SupplementTypeMetaData[] {
        return SupplementTypeMetaData.allItems;
    }

    constructor(
        public type: TCITenantAppType,
        public category: TCITenantAppCategory,
        public options: ITCISupplementTypeMetaDataOption[],
        public enabled: boolean,
        public displayName: string
    ) {
    }
}

export const supportedSupplementFileSpecs = (): ITCISupplementUploadSupportedFile[] =>
     [
         {
            extension: "zip",
            optional: false
         },
         {
             extension: "conf",
             optional: false
         },
         {
             extension: "jar",
             optional: false
         }
    ];
